import { Component } from '@angular/core';
import { Wrapper } from '../../components/wrapper.component';
import { Budget, BudgetSummary } from '../../store/reselectors/budget.data';
import { OnInit } from '@angular/core';
import { JoiEvent } from 'src/app/store/events.era';
import { eventReadOnlyReselector, eventStatusReselector } from '../../store/reselectors/events.reselector';
import { budgetSummaryReselector, budgetCashFlowGridReselector } from '../../store/reselectors/budget.reselector';
import { CashFlowGridData } from '../../helpers/grid-helpers';
import { BudgetSnapshotDialogData } from './costs-view-dialog.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { BudgetSummaryViewDialogComponent } from './summary-view-dialog.component';
import { EventStatus, SnapshotInfo } from 'globals/store/events.data';
import { TopMenuComponent } from '../program/top.menu';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { CommonModule } from '@angular/common';
import { BudgetReportViewComponent } from './budget-report-view.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { traceNames } from 'src/app/services/performance.tracking.data';

@Component({
    selector: 'budget-report',
    templateUrl: './budget-report.html',
    styleUrls: ['../../page.scss', './budget-report.scss', './revenue.scss', '../../components/timeline/snapshot.scss'],
    styles: [`
  .snapshot { margin-left: 10px; cursor: pointer; }
  
  `],
    standalone: true,
    imports: [TopMenuComponent, LoaderPaneFragmentComponent, CommonModule, BudgetReportViewComponent, MatMenuModule, MatProgressSpinnerModule],
})
export class BudgetReportComponent extends Wrapper<BudgetReportComponent> implements OnInit {
  budget: Budget
  event: JoiEvent
  eventStatus: EventStatus
  readOnly: boolean = false
  closed = true
  traceNames = traceNames;
  budgetSummary: BudgetSummary
  cashFlowGrid: CashFlowGridData[]
  savingSnapshot = false

  ngOnInit() {
    this.subProp(this.store.select('budget', 'budget'), 'budget')
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select(eventStatusReselector), 'eventStatus')
    this.subProp(this.store.select(budgetSummaryReselector), 'budgetSummary')
    this.subProp(this.store.select(budgetCashFlowGridReselector), 'cashFlowGrid')
    this.selectProp(eventReadOnlyReselector, null, 'closed')
  }

  async saveSnapshot() {
    this.savingSnapshot = true

    const n = this.budget.summarySnapshots.length
    const name = n ? `Snapshot ${(+this.budget.summarySnapshots[n-1].name.split("Snapshot ")[1] + 1)}` : 'Snapshot 1'

    const info: SnapshotInfo = {
      id: await this.shareService.generateShareCode(),
      name,
      timestamp: new Date().getTime()
    }
    
    await this.eventService.uploadBudgetSnapshot(info, this.budget, 'summary')
    this.budget.summarySnapshots.push(info)
    await this.budgetService.updateBudget(this.event.eventId, this.budget)

    this.savingSnapshot = false
  }

  async openSnapshot(info: SnapshotInfo) {
    const data: BudgetSnapshotDialogData = { info, eventId: this.event.eventId }
    await openDialogGetResult(this.dialog, BudgetSummaryViewDialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
  }

  saveBudget() {
    this.budgetService.updateBudget(this.event.eventId, this.budget)
  }

}